import type { ReactNode } from 'react';
import './ReputationBar.scss';

interface ReputationBarProps {
  label: string;
  score: number;
  confidence: number;
  children?: ReactNode;
}

export function ReputationBar({ label, score, confidence, children }: ReputationBarProps) {
  const clamped = Math.max(0, Math.min(100, score));
  return (
    <div className="reputation-bar">
      <div className="reputation-bar__label">
        <span>{label}</span>
        <span>{clamped}</span>
      </div>
      <div className="reputation-bar__track">
        <div
          className="reputation-bar__fill"
          style={{ width: `${clamped}%`, opacity: 0.4 + confidence * 0.6 }}
        />
      </div>
      {children && <div className="reputation-bar__evidence">{children}</div>}
    </div>
  );
}
